//WE.Flow.Html.Contracts.Credits.LicenseFile

export class LicenseFile {
    name: string = "";
    description: string = "";
}
